// extracted by mini-css-extract-plugin
export default {"overlay":"oz-z","bodyOpen":"pz-z","content":"qz-z","header":"rz-z","close":"sz-z","closeNoHeading":"tz-z"};